/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAiSettingsShow } from '../../axios/organisationAiSettingsShow'
import type {
	OrganisationAiSettingsShowError,
	OrganisationAiSettingsShowPathParams,
	OrganisationAiSettingsShowResponse,
} from '../../types/OrganisationAiSettingsShow'

export const organisationAiSettingsShowQueryKey = (
	organisation: OrganisationAiSettingsShowPathParams['organisation'],
) => [{ url: '/organisations/:organisation/ai-settings', params: { organisation } }] as const

export type OrganisationAiSettingsShowQueryKey = ReturnType<typeof organisationAiSettingsShowQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAiSettingsController.php OrganisationAiSettingsController::show */
export function organisationAiSettingsShowQueryOptions(
	organisation: OrganisationAiSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationAiSettingsShowResponse,
		AxiosError<OrganisationAiSettingsShowError>,
		OrganisationAiSettingsShowResponse,
		OrganisationAiSettingsShowQueryKey
	>({
		queryKey: organisationAiSettingsShowQueryKey(organisation),
		queryFn: ({ signal }) => organisationAiSettingsShow(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAiSettingsController.php OrganisationAiSettingsController::show */
export function useOrganisationAiSettingsShow<TSelectData = OrganisationAiSettingsShowResponse>(
	organisation: OrganisationAiSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationAiSettingsShowResponse,
					AxiosError<OrganisationAiSettingsShowError>,
					TSelectData,
					OrganisationAiSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationAiSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationAiSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAiSettingsController.php OrganisationAiSettingsController::show */
export function useOrganisationAiSettingsShowSuspense<TSelectData = OrganisationAiSettingsShowResponse>(
	organisation: OrganisationAiSettingsShowPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationAiSettingsShowResponse,
					AxiosError<OrganisationAiSettingsShowError>,
					TSelectData,
					OrganisationAiSettingsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationAiSettingsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationAiSettingsShowQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
